import React, { useEffect, useState, createElement } from 'react';
import { Header } from '../components/Header';
import { Footer } from '../components/Footer';
import { MailIcon, PhoneIcon, GlobeIcon, Loader2Icon } from 'lucide-react';
export const AboutPage = () => {
  const [isVideoLoaded, setIsVideoLoaded] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  useEffect(() => {
    // Preload the video
    const preloadVideo = document.createElement('video');
    preloadVideo.src = 'https://media.githubusercontent.com/media/DanteMagg/danyi-video-storage/main/RPReplay_Final1725085456%202.mov';
    preloadVideo.preload = 'auto';
  }, []);
  const handleVideoLoaded = () => {
    setIsVideoLoaded(true);
    setIsLoading(false);
  };
  const handleVideoError = () => {
    setIsLoading(false);
    setIsVideoLoaded(false);
  };
  return <div className="min-h-screen bg-[#f2f2ed]" data-id="element-857">
      <Header data-id="element-858" />
      <main className="pt-32 pb-20" data-id="element-859">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-860">
          <div className="mb-16" data-id="element-861">
            <h1 className="text-6xl md:text-7xl lg:text-8xl font-normal text-[#3a4a56] leading-tight mb-12" data-id="element-862">
              About us
            </h1>
          </div>
          <div className="mb-24 relative" data-id="element-863">
            <p className="text-sm uppercase tracking-wider text-[#3a4a56] font-medium mb-6" data-id="element-864">
              WELCOME TO IMMOVENDU
            </p>
            <div className="relative aspect-video w-full" data-id="element-865">
              {isLoading && <div className="absolute inset-0 flex items-center justify-center bg-gray-900" data-id="element-866">
                  <Loader2Icon className="w-12 h-12 text-white animate-spin" data-id="element-867" />
                </div>}
              <video className={`w-full h-full object-cover transition-opacity duration-500 ${isVideoLoaded ? 'opacity-100' : 'opacity-0'}`} autoPlay loop muted playsInline preload="auto" onLoadedData={handleVideoLoaded} onError={handleVideoError} data-id="element-868">
                <source src="https://media.githubusercontent.com/media/DanteMagg/danyi-video-storage/main/RPReplay_Final1725085456%202.mov" type="video/mp4" data-id="element-869" />
                Your browser does not support the video tag.
              </video>
            </div>
          </div>
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 mb-32" data-id="element-870">
            <div data-id="element-871">
              <h2 className="text-4xl md:text-5xl font-normal text-[#3a4a56] leading-tight mb-10" data-id="element-872">
                Born from nearly 20 years of real estate success, Immovendu is
                the next chapter for Montreal's luxury property market.
              </h2>
            </div>
            <div className="text-[#3a4a56]" data-id="element-873">
              <p className="text-lg mb-8" data-id="element-874">
                Immovendu is a Montreal-based real estate agency built on the
                belief that property services should partner with your own
                vision. That means smart, targeted service of proven expertise
                and gentle, client-centered guidance, delivered precisely where
                they matter.
              </p>
              <p className="text-lg mb-8" data-id="element-875">
                Each property is carefully evaluated, each client relationship
                nurtured, and each transaction managed with precision until it
                earns its place in your success story.
              </p>
              <p className="text-lg" data-id="element-876">
                Inspired by Montreal's changing seasons and driven by a
                longevity mindset. Our goal is simple: to support lasting
                property investments and relationships — so you can feel
                confident in yours, today and for years to come.
              </p>
            </div>
          </div>
          <div className="mb-32" data-id="element-877">
            <div className="mb-16" data-id="element-878">
              <h6 className="text-sm uppercase tracking-wider text-[#3a4a56] font-medium mb-6" data-id="element-879">
                Meet Our
              </h6>
              <h2 className="text-4xl md:text-5xl font-normal text-[#3a4a56] leading-tight mb-10" data-id="element-880">
                Innovative Team
              </h2>
              <p className="text-lg text-[#3a4a56] max-w-3xl" data-id="element-881">
                Welcome to Immovendu, where buying or selling a home is more
                than just a transaction – it's an exciting experience. Our team
                is committed to personalized service, guiding you every step of
                the way. We listen to your needs and provide tailored solutions
                to help you find the perfect property.
              </p>
            </div>
            <div className="mt-16" data-id="element-882"></div>
          </div>
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 mb-32 items-center" data-id="element-883">
            <div data-id="element-884">
              <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/2pFzUNAG1d8BqZA5VbFe6G/img-danyi.jpg" alt="Danyi Wang" className="w-full h-auto" data-id="element-885" />
            </div>
            <div data-id="element-886">
              <div className="text-[#3a4a56] max-w-xl" data-id="element-887">
                <h2 className="text-4xl md:text-5xl font-normal leading-tight mb-10" data-id="element-888">
                  Every property is shaped by the hands-on expertise of Danyi
                  Wang
                </h2>
                <p className="text-xl mb-8" data-id="element-889">
                  Known for her personalized approach, Danyi excels at matching
                  clients with their dream homes. She's a trusted advisor,
                  bringing passion, attention to detail, and negotiation skills
                  to every deal. With a background in psychology, behavioral
                  neuroscience, and art history from McGill University, Danyi
                  offers a unique perspective on understanding clients' needs
                  and preferences.
                </p>
              </div>
            </div>
          </div>
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-20 mb-32" data-id="element-890">
            <div data-id="element-891">
              <h3 className="text-sm uppercase tracking-wider text-[#3a4a56] font-medium mb-6" data-id="element-892">
                MONTREAL EXPERTISE
              </h3>
              <div className="text-[#3a4a56]" data-id="element-893">
                <p className="text-lg mb-6" data-id="element-894">
                  We're shaped by a Montreal mindset: diverse, resilient, and
                  balanced. Living in this dynamic city has taught us real
                  strength comes from within — and lasting results come from
                  working with people.
                </p>
                <p className="text-lg" data-id="element-895">
                  This guides everything we do: client-centered real estate
                  services based on understanding, not trends. Every transaction
                  reflects our commitment to service-driven, targeted solutions
                  that support long-term property value at every stage of life.
                </p>
              </div>
            </div>
            <div data-id="element-896">
              <h3 className="text-sm uppercase tracking-wider text-[#3a4a56] font-medium mb-6" data-id="element-897">
                CLIENT-FIRST APPROACH
              </h3>
              <div className="text-[#3a4a56]" data-id="element-898">
                <p className="text-lg mb-6" data-id="element-899">
                  Real estate is no longer just about selling what we see. It's
                  about caring for the investments we want to protect. At
                  Immovendu, our philosophy is built on longevity — supporting
                  each client's natural ability to make confident decisions.
                </p>
                <p className="text-lg" data-id="element-900">
                  We combine market expertise and client-compatible strategies
                  that work in synergy to secure, protect, and strengthen your
                  investment over time. This shapes every service in our
                  approach, designed to help you thrive now and for the future.
                </p>
              </div>
            </div>
          </div>
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 mb-32" data-id="element-901">
            <div data-id="element-902">
              <h2 className="text-4xl font-normal text-[#3a4a56] leading-tight mb-10" data-id="element-903">
                Contact us to begin your real estate journey
              </h2>
            </div>
            <div data-id="element-904">
              <form className="space-y-6" data-id="element-905">
                <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-906">
                  <div data-id="element-907">
                    <input type="text" className="w-full px-4 py-3 border-b border-[#3a4a56] bg-transparent focus:outline-none focus:border-[#00A3E0]" placeholder="First Name" data-id="element-908" />
                  </div>
                  <div data-id="element-909">
                    <input type="text" className="w-full px-4 py-3 border-b border-[#3a4a56] bg-transparent focus:outline-none focus:border-[#00A3E0]" placeholder="Last Name" data-id="element-910" />
                  </div>
                </div>
                <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-911">
                  <div data-id="element-912">
                    <input type="email" className="w-full px-4 py-3 border-b border-[#3a4a56] bg-transparent focus:outline-none focus:border-[#00A3E0]" placeholder="Email Address" data-id="element-913" />
                  </div>
                  <div data-id="element-914">
                    <input type="tel" className="w-full px-4 py-3 border-b border-[#3a4a56] bg-transparent focus:outline-none focus:border-[#00A3E0]" placeholder="Phone" data-id="element-915" />
                  </div>
                </div>
                <div data-id="element-916">
                  <textarea className="w-full px-4 py-3 border-b border-[#3a4a56] bg-transparent focus:outline-none focus:border-[#00A3E0]" rows={4} placeholder="Message" data-id="element-917"></textarea>
                </div>
                <div data-id="element-918">
                  <button type="submit" className="bg-[#3a4a56] hover:bg-[#2a3a46] text-white font-medium py-3 px-8 transition duration-200" data-id="element-919">
                    Submit
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </main>
      <Footer data-id="element-920" />
    </div>;
};